import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IStockSucursalData } from '@core/interfaces/entidades/stock-sucursal.entidad';
import { ISucursalData } from '@core/interfaces/entidades/sucursal.entidad';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class SucursalApiService extends BaseHttpService {
  listar() {
    return this.withLoader(
      this.httpClient.get<ISucursalData[]>(
        `${environment.apiUrl}${environment.apiPreFix}/sucursal/cargar-todos`,
      ),
    );
  }

  obtenerPrincipal() {
    return this.httpClient.get<ISucursalData>(
      `${environment.apiUrl}${environment.apiPreFix}/sucursal/principal`,
    );
  }

  cargar(sucursalId: number) {
    return this.httpClient.get<ISucursalData>(
      `${environment.apiUrl}${environment.apiPreFix}/sucursal/cargar/${sucursalId}`,
    );
  }
  actualizar(sucursalId: number, rq: Partial<ISucursalData>) {
    return this.withLoader(
      this.httpClient.patch<ISucursalData>(
        `${environment.apiUrl}${environment.apiPreFix}/sucursal/actualizar/${sucursalId}`,
        rq,
      ),
    );
  }

  // STOCK
  stockPorSucursal(sucursalId: number) {
    return this.httpClient.get<IStockSucursalData[]>(
      `${environment.apiUrl}${environment.apiPreFix}/sucursal/stock/sucursal/${sucursalId}`,
    );
  }

  stockPorProducto(productoId: number) {
    return this.httpClient.get<IStockSucursalData[]>(
      `${environment.apiUrl}${environment.apiPreFix}/sucursal/stock/producto/${productoId}`,
    );
  }

  stockProductoEnSucursal(productoId: number, sucursalId: number) {
    return this.httpClient.get<IStockSucursalData>(
      `${environment.apiUrl}${environment.apiPreFix}/sucursal/stock/producto/${productoId}/sucursal/${sucursalId}`,
    );
  }

  actualizarStock(productoId: number, sucursalId: number, stock: number) {
    const params = new HttpParams().set('stock', stock.toString());
    return this.withLoader(
      this.httpClient.patch(
        `${environment.apiUrl}${environment.apiPreFix}/sucursal/stock/producto/${productoId}/sucursal/${sucursalId}`,
        {},
        { params },
      ),
    );
  }

  transferirStock(rq: {
    producto_id: number;
    sucursal_origen_id: number;
    sucursal_destino_id: number;
    cantidad: number;
  }) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/sucursal/stock/transferir`,
        rq,
      ),
    );
  }
}
